import React, { useState, useMemo } from "react";
import useSWR from "swr";
import "../../../commons/styles/react-widgets-styles.css";
import DatePicker2 from "react-widgets/DatePicker";
import { Button, Card } from "reactstrap";
import { AreaChartData } from "../../../commons/components/AreaChartData.jsx";
import { Skeleton } from "../../../commons/components/skeleton/Skeleton";
import sumarDias from "../../../commons/functions/sumarDias";
import url from "../../../config/url";
import SimpleBarGraph from "./SimpleBarGraph";
import { BombaElectrica } from "./components/icons";

const styles = {
  pageTitle: {
    color: "#303D48",
    marginBottom: "10px",
    marginLeft: "10px"
  },
  breadcrumb: {
    marginLeft: "10px",
    marginBottom: "20px"
  },
  breadcrumbNav: {
    fontSize: "14px",
    color: "#6c757d"
  },
  breadcrumbLink: {
    color: "#333",
    textDecoration: "none",
    fontWeight: "normal"
  },
  breadcrumbSeparator: {
    margin: "0 8px",
    color: "#6c757d"
  },
  breadcrumbActive: {
    color: "#6c757d",
    fontWeight: "bold"
  },
  sectionTitle: {
    color: "#6c757d",
    fontSize: "16px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "30px"
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    marginBottom: "40px",
    maxWidth: "100%"
  },
  mainCard: {
    minHeight: "80px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    padding: "20px",
    backgroundColor: "#fff",
    borderLeft: "4px solid #007bff",
    flex: "1 1 280px",
    minWidth: "250px",
    maxWidth: "100%",
    boxSizing: "border-box",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  mainCardHover: {
    backgroundColor: "#e3f2fd",
    transform: "scale(1.02)",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
  },
  mainCardSelected: {
    backgroundColor: "#bbdefb",
    borderLeft: "4px solid #2196f3"
  },
  metricLabelContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  metricLabel: {
    fontSize: "14px",
    color: "#333",
    fontWeight: "600",
    margin: "0",
    lineHeight: "1.2"
  },
  metricSubLabel: {
    fontSize: "14px",
    color: "#333",
    fontWeight: "600",
    margin: "0",
    lineHeight: "1.2"
  },
  metricValueContainer: {
    display: "flex",
    alignItems: "baseline",
    textAlign: "right"
  },
  metricValue: {
    fontSize: "36px",
    fontWeight: "300",
    color: "#333",
    lineHeight: "1",
    margin: "0"
  },
  metricUnit: {
    fontSize: "16px",
    color: "#6c757d",
    marginLeft: "8px",
    fontWeight: "500"
  },
  pumpContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "30px",
    marginBottom: "40px",
    maxWidth: "1400px",
    margin: "0 auto 40px auto"
  },
  pumpCard: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: "0",
    backgroundColor: "transparent",
    width: "100%",
    minHeight: "280px",
    marginBottom: "20px",
    cursor: "pointer",
    transition: "transform 0.2s ease"
  },
  pumpCardSelected: {
    transform: "scale(1.02)",
    opacity: "0.9"
  },
  pumpIconContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: "10px",
    minWidth: "80px",
    maxWidth: "80px",
    justifyContent: "flex-start"
  },
  pumpIcon: {
    transform: "scale(0.6)"
  },
  pumpLabel: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#333",
    textAlign: "center",
    margin: "0",
    marginRight: "10px"
  },
  pumpMetricsContainer: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    minHeight: "240px"
  },
  pumpMetricRow: {
    backgroundColor: "#f8f9fa",
    boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
    borderRadius: "5px",
    padding: "14px 18px",
    display: "flex",
    gap: "12px",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    minHeight: "55px",
    flex: "1"
  },
  pumpMetricRowHover: {
    backgroundColor: "#e3f2fd",
    transform: "scale(1.02)",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
  },
  pumpMetricRowSelected: {
    backgroundColor: "#bbdefb",
    borderLeft: "4px solid #2196f3"
  },
  pumpMetricLabel: {
    fontSize: "13px",
    color: "#007bff",
    fontWeight: "600",
    margin: "0"
  },
  pumpMetricValueContainer: {
    display: "flex",
    alignItems: "baseline"
  },
  pumpMetricValue: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#333",
    margin: "0"
  },
  pumpMetricUnit: {
    fontSize: "13px",
    color: "#6c757d",
    marginLeft: "4px"
  },
  statusBadge: {
    color: "white",
    padding: "4px 12px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "600",
    border: "none"
  },
  totalizadorSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "800px",
    margin: "0 auto",
    marginBottom: "20px"
  },
  totalizadorContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    justifyContent: "center",
    maxWidth: "100%"
  },
  totalizadorCard: {
    minHeight: "80px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    padding: "20px",
    backgroundColor: "#fff",
    borderLeft: "4px solid #007bff",
    flex: "1 1 300px",
    minWidth: "280px",
    maxWidth: "100%",
    boxSizing: "border-box"
  },
  totalizadorLabelContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  totalizadorLabel: {
    fontSize: "14px",
    color: "#333",
    fontWeight: "600",
    margin: "0",
    lineHeight: "1.2"
  },
  totalizadorSubLabel: {
    fontSize: "14px",
    color: "#333",
    fontWeight: "600",
    margin: "0",
    lineHeight: "1.2"
  },
  totalizadorValueContainer: {
    display: "flex",
    alignItems: "baseline",
    textAlign: "right"
  },
  totalizadorValue: {
    fontSize: "36px",
    fontWeight: "300",
    color: "#333",
    lineHeight: "1",
    margin: "0"
  },
  totalizadorUnit: {
    fontSize: "16px",
    color: "#6c757d",
    marginLeft: "8px",
    fontWeight: "500"
  },
  dateRangeCard: {
    padding: "20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    borderRadius: "8px"
  },
  dateRange: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px"
  },
  dateText: {
    fontSize: "14px",
    color: "#333",
    fontWeight: "600"
  },
  chartCard: {
    padding: "20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    backgroundColor: "#fff"
  },
  variableMonitoreada: {
    textAlign: "center",
    fontSize: "16px",
    color: "#666",
    fontStyle: "italic",
    marginBottom: "20px"
  }
};

// Componente Skeleton Loader
function ParametrosElectricosSkeleton() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
        maxWidth: "100%",
        width: "100%",
        boxSizing: "border-box",
        overflowX: "hidden"
      }}>
      {/* Skeleton Analizador de Red */}
      <div>
        <Skeleton
          style={{ width: "200px", height: "24px", margin: "0 auto 30px" }}
        />
        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          {[1, 2, 3].map((i) => (
            <Skeleton
              key={i}
              style={{
                flex: "1 1 300px",
                height: "80px",
                borderRadius: "8px"
              }}
            />
          ))}
        </div>
      </div>

      {/* Skeleton Parámetros Bombas */}
      <div>
        <Skeleton
          style={{ width: "200px", height: "24px", margin: "30px auto 30px" }}
        />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "30px"
          }}>
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              style={{ display: "flex", gap: "10px" }}>
              <Skeleton
                style={{ width: "80px", height: "240px", borderRadius: "8px" }}
              />
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                }}>
                {[1, 2, 3, 4].map((j) => (
                  <Skeleton
                    key={j}
                    style={{ height: "55px", borderRadius: "5px" }}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Skeleton Totalizadores */}
      <div style={{ maxWidth: "800px", margin: "0 auto", width: "100%" }}>
        <Skeleton
          style={{ width: "200px", height: "24px", margin: "30px auto 30px" }}
        />
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            justifyContent: "center"
          }}>
          {[1, 2].map((i) => (
            <Skeleton
              key={i}
              style={{
                flex: "1 1 300px",
                minWidth: "300px",
                height: "80px",
                borderRadius: "8px"
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export function ParametrosElectricos({
  idPlanta = 23,
  nombrePlanta = "SCADA Terranova 1"
}) {
  const responsiveCSS = `
    .pump-container-responsive {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(min(100%, 350px), 1fr));
      gap: 30px;
      margin-bottom: 40px;
      max-width: 100%;
      width: 100%;
      margin: 0 auto 40px auto;
      box-sizing: border-box;
    }

    @media (max-width: 767px) {
      .pump-container-responsive {
        grid-template-columns: 1fr;
      }
    }
  `;

  const getBombaPrefix = () => {
    if (nombrePlanta.includes("Terranova 4")) {
      return 300;
    }
    return 200;
  };

  const bombaPrefix = getBombaPrefix();

  const [startDate, setStartDate] = useState(sumarDias(new Date(), -6));
  const [endDate, setEndDate] = useState(new Date());
  const [searchDates, setSearchDates] = useState({
    start: sumarDias(new Date(), -6),
    end: new Date()
  });
  const [variableSeleccionada, setVariableSeleccionada] = useState({
    column: null,
    title: null
  });
  const [hoveredMetric, setHoveredMetric] = useState(null);
  const [hoveredAnalyzer, setHoveredAnalyzer] = useState(null);

  // Fetcher para SWR
  const fetcher = async (url) => {
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json"
        // Si necesitas auth (cuando la actives):
        // 'Token': localStorage.getItem('token'),
        // 'Id-User': localStorage.getItem('userId')
      }
    });

    if (!response.ok) {
      throw new Error("Error al cargar datos");
    }

    const result = await response.json();
    return result.data;
  };

  // Usar SWR para cargar datos con revalidación automática
  const { data, error, isLoading } = useSWR(
    `${url}electric/latest_params/${idPlanta}`,
    fetcher,
    {
      refreshInterval: 5000, // Recargar cada 5 segundos
      revalidateOnFocus: false, // No recargar al enfocar la ventana
      dedupingInterval: 2000 // Deduplicar requests durante 2 segundos
    }
  );

  // Función helper para obtener un parámetro por nombre
  const getParametro = (nombre) => {
    if (!data || !data.parametros) return null;
    return data.parametros.find((p) => p.nombre === nombre);
  };

  // Función helper para obtener estado en texto
  const getEstadoTexto = (valor) => {
    if (valor === 0) return "En Funcionamiento";
    if (valor === 1) return "En Falla";
    return "Desconocido";
  };

  // Función helper para obtener color según estado
  const getEstadoColor = (valor) => {
    if (valor === 0) return "#28a745"; // Verde
    if (valor === 1) return "#dc3545"; // Rojo
    return "#6c757d"; // Gris
  };

  // Datos del analizador de red desde la API
  const analizadorData = useMemo(() => {
    if (!data || !data.parametros) {
      return {
        potenciaActiva: { valor: 0, columna: null, unidad: "KW" },
        potenciaReactiva: { valor: 0, columna: null, unidad: "KVAR" },
        energia: { valor: 0, columna: null, unidad: "KVA" }
      };
    }

    const potenciaActiva = data.parametros.find(
      (p) => p.nombre === "POTENCIA ACTIVA"
    );
    const potenciaReactiva = data.parametros.find(
      (p) => p.nombre === "POTENCIA REACTIVA"
    );
    const potenciaAparente = data.parametros.find(
      (p) => p.nombre === "POTENCIA APARENTE"
    );

    return {
      potenciaActiva: {
        valor: potenciaActiva ? potenciaActiva.valor : 0,
        columna: potenciaActiva ? potenciaActiva.columna : null,
        unidad: potenciaActiva ? potenciaActiva.unidad : "KW"
      },
      potenciaReactiva: {
        valor: potenciaReactiva ? potenciaReactiva.valor : 0,
        columna: potenciaReactiva ? potenciaReactiva.columna : null,
        unidad: potenciaReactiva ? potenciaReactiva.unidad : "KVAR"
      },
      energia: {
        valor: potenciaAparente ? potenciaAparente.valor : 0,
        columna: potenciaAparente ? potenciaAparente.columna : null,
        unidad: potenciaAparente ? potenciaAparente.unidad : "KVA"
      }
    };
  }, [data]);

  // Datos de las bombas desde la API
  const bombasData = useMemo(() => {
    if (!data || !data.parametros) {
      return [];
    }

    // Agrupar parámetros por bomba
    const bombasPorNumero = {};

    data.parametros.forEach((param) => {
      // Detectar si es un parámetro de bomba (formato: P200_POTENCIA, P201_POTENCIA, etc.)
      const match = param.nombre.match(/^P(\d+)_(.+)$/);
      if (match) {
        const bombaNum = match[1];
        const tipo = match[2];

        if (!bombasPorNumero[bombaNum]) {
          bombasPorNumero[bombaNum] = {
            id: `P-${bombaNum}`,
            title: `P-${bombaNum}`,
            potencia: null,
            corriente: null,
            frecuencia: null,
            estado: null,
            color: "#6c757d"
          };
        }

        if (tipo === "POTENCIA") {
          bombasPorNumero[bombaNum].potencia = {
            value: param.valor,
            column: param.columna,
            unidad: param.unidad
          };
        } else if (tipo === "INTENCIDAD") {
          bombasPorNumero[bombaNum].corriente = {
            value: param.valor,
            column: param.columna,
            unidad: param.unidad
          };
        } else if (tipo === "FRECUENCIA") {
          bombasPorNumero[bombaNum].frecuencia = {
            value: param.valor,
            column: param.columna,
            unidad: param.unidad
          };
        } else if (tipo === "FALLA") {
          bombasPorNumero[bombaNum].estado = {
            value: getEstadoTexto(param.valor),
            column: param.columna
          };
          bombasPorNumero[bombaNum].color = getEstadoColor(param.valor);
        }
      }
    });

    return Object.values(bombasPorNumero);
  }, [data]);

  // Obtener datos del totalizador desde la API
  const totalizadorData = useMemo(() => {
    if (!data || !data.parametros) {
      return { horasFuncionamiento: 0, contadorArranques: 0 };
    }

    const horasFuncionamiento = data.parametros.find(
      (p) => p.nombre === "HORAS FUNCIONAMIENTO"
    );
    const contadorArranques = data.parametros.find(
      (p) => p.nombre === "CONTADOR DE ARRANQUE"
    );

    return {
      horasFuncionamiento: horasFuncionamiento ? horasFuncionamiento.valor : 0,
      horasFuncionamientoColumn: horasFuncionamiento
        ? horasFuncionamiento.columna
        : null,
      contadorArranques: contadorArranques ? contadorArranques.valor : 0,
      contadorArranquesColumn: contadorArranques
        ? contadorArranques.columna
        : null
    };
  }, [data]);

  // Función para manejar el clic en una bomba
  const handleVariableClick = (column, title) => {
    setVariableSeleccionada({
      column,
      title
    });

    // Hacer scroll hasta el fondo de la página con un pequeño delay para asegurar que el estado se actualice
    setTimeout(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth"
      });
    }, 100);
  };

  // Función para buscar datos
  const onClickBuscarDatos = () => {
    setSearchDates({
      start: startDate,
      end: endDate
    });
  };

  return (
    <section>
      <style>{responsiveCSS}</style>
      <section>
        <h1
          className="card-header-title font-size-lg font-weight-bold text-uppercase"
          style={styles.pageTitle}>
          PARÁMETROS ELÉCTRICOS
        </h1>

        {/* Breadcrumb */}
        <nav style={styles.breadcrumb}>
          <div style={styles.breadcrumbNav}>
            <span style={styles.breadcrumbLink}>IdA</span>
            <span style={styles.breadcrumbSeparator}>/</span>
            <span style={styles.breadcrumbLink}>Plantas</span>
            <span style={styles.breadcrumbSeparator}>/</span>
            <span style={styles.breadcrumbLink}>Blueberries</span>
            <span style={styles.breadcrumbSeparator}>/</span>
            <span style={styles.breadcrumbLink}>{nombrePlanta}</span>
            <span style={styles.breadcrumbSeparator}>/</span>
            <span style={styles.breadcrumbActive}>Parámetros Eléctricos</span>
          </div>
        </nav>
      </section>

      {isLoading && !data ? (
        <ParametrosElectricosSkeleton />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
            maxWidth: "100%",
            width: "100%",
            boxSizing: "border-box",
            overflowX: "hidden"
          }}>
          {/* Título de la página */}

          {/* Analizador de Red */}
          <div>
            <h2 style={styles.sectionTitle}>Analizador de Red</h2>
            <div style={styles.container}>
              <div
                style={{
                  ...styles.mainCard,
                  ...(hoveredAnalyzer === "potencia-activa"
                    ? styles.mainCardHover
                    : {}),
                  ...(variableSeleccionada.column ===
                  analizadorData.potenciaActiva.columna
                    ? styles.mainCardSelected
                    : {})
                }}
                onClick={() => {
                  analizadorData.potenciaActiva.columna &&
                    handleVariableClick(
                      analizadorData.potenciaActiva.columna,
                      "Potencia Activa"
                    );
                }}
                onMouseEnter={() => setHoveredAnalyzer("potencia-activa")}
                onMouseLeave={() => setHoveredAnalyzer(null)}>
                <div style={styles.metricLabelContainer}>
                  <p style={styles.metricLabel}>Potencia</p>
                  <p style={styles.metricSubLabel}>Activa</p>
                </div>
                <div style={styles.metricValueContainer}>
                  <span style={styles.metricValue}>
                    {analizadorData.potenciaActiva.valor}
                  </span>
                  <span style={styles.metricUnit}>
                    {analizadorData.potenciaActiva.unidad}
                  </span>
                </div>
              </div>

              <div
                style={{
                  ...styles.mainCard,
                  ...(hoveredAnalyzer === "potencia-reactiva"
                    ? styles.mainCardHover
                    : {}),
                  ...(variableSeleccionada.column ===
                  analizadorData.potenciaReactiva.columna
                    ? styles.mainCardSelected
                    : {})
                }}
                onClick={() => {
                  analizadorData.potenciaReactiva.columna &&
                    handleVariableClick(
                      analizadorData.potenciaReactiva.columna,
                      "Potencia Reactiva"
                    );
                }}
                onMouseEnter={() => setHoveredAnalyzer("potencia-reactiva")}
                onMouseLeave={() => setHoveredAnalyzer(null)}>
                <div style={styles.metricLabelContainer}>
                  <p style={styles.metricLabel}>Potencia</p>
                  <p style={styles.metricSubLabel}>Reactiva</p>
                </div>
                <div style={styles.metricValueContainer}>
                  <span style={styles.metricValue}>
                    {analizadorData.potenciaReactiva.valor}
                  </span>
                  <span style={styles.metricUnit}>
                    {analizadorData.potenciaReactiva.unidad}
                  </span>
                </div>
              </div>

              <div
                style={{
                  ...styles.mainCard,
                  ...(hoveredAnalyzer === "energia"
                    ? styles.mainCardHover
                    : {}),
                  ...(variableSeleccionada.column ===
                  analizadorData.energia.columna
                    ? styles.mainCardSelected
                    : {})
                }}
                onClick={() => {
                  analizadorData.energia.columna &&
                    handleVariableClick(
                      analizadorData.energia.columna,
                      "Energía"
                    );
                }}
                onMouseEnter={() => setHoveredAnalyzer("energia")}
                onMouseLeave={() => setHoveredAnalyzer(null)}>
                <div style={styles.metricLabelContainer}>
                  <p style={styles.metricLabel}>Energía</p>
                </div>
                <div style={styles.metricValueContainer}>
                  <span style={styles.metricValue}>
                    {analizadorData.energia.valor}
                  </span>
                  <span style={styles.metricUnit}>
                    {analizadorData.energia.unidad}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Parámetros Bombas */}
          <div>
            <h2 style={styles.sectionTitle}>Parámetros Bombas</h2>
            <div className="pump-container-responsive">
              {bombasData.map((bomba, index) => (
                <div
                  key={bomba.id}
                  style={{ display: "flex" }}>
                  {/* Icono y etiqueta de la bomba */}
                  <div style={styles.pumpIconContainer}>
                    <div style={styles.pumpIcon}>
                      <BombaElectrica circleColor={bomba.color} />
                    </div>
                    <p style={styles.pumpLabel}>{bomba.id}</p>
                  </div>

                  {/* Métricas */}
                  <div style={styles.pumpMetricsContainer}>
                    {/* Potencia */}
                    <div
                      style={{
                        ...styles.pumpMetricRow,
                        ...(hoveredMetric === `${bomba.id}-potencia`
                          ? styles.pumpMetricRowHover
                          : {}),
                        ...(variableSeleccionada.column ===
                        (bomba.potencia && bomba.potencia.column)
                          ? styles.pumpMetricRowSelected
                          : {})
                      }}
                      onClick={() =>
                        bomba.potencia &&
                        bomba.potencia.column &&
                        handleVariableClick(
                          bomba.potencia.column,
                          `${bomba.title} - Potencia`
                        )
                      }
                      onMouseEnter={() =>
                        setHoveredMetric(`${bomba.id}-potencia`)
                      }
                      onMouseLeave={() => setHoveredMetric(null)}>
                      <span style={styles.pumpMetricLabel}>Potencia</span>
                      <div style={styles.pumpMetricValueContainer}>
                        <span style={styles.pumpMetricValue}>
                          {bomba.potencia && bomba.potencia.value
                            ? bomba.potencia.value
                            : 0}
                        </span>
                        <span style={styles.pumpMetricUnit}>
                          {bomba.potencia && bomba.potencia.unidad
                            ? bomba.potencia.unidad
                            : "kW"}
                        </span>
                      </div>
                    </div>

                    {/* Frecuencia */}
                    <div
                      style={{
                        ...styles.pumpMetricRow,
                        ...(hoveredMetric === `${bomba.id}-frecuencia`
                          ? styles.pumpMetricRowHover
                          : {}),
                        ...(variableSeleccionada.column ===
                        (bomba.frecuencia && bomba.frecuencia.column)
                          ? styles.pumpMetricRowSelected
                          : {})
                      }}
                      onClick={() =>
                        bomba.frecuencia &&
                        bomba.frecuencia.column &&
                        handleVariableClick(
                          bomba.frecuencia.column,
                          `${bomba.title} - Frecuencia`
                        )
                      }
                      onMouseEnter={() =>
                        setHoveredMetric(`${bomba.id}-frecuencia`)
                      }
                      onMouseLeave={() => setHoveredMetric(null)}>
                      <span style={styles.pumpMetricLabel}>Frecuencia</span>
                      <div style={styles.pumpMetricValueContainer}>
                        <span style={styles.pumpMetricValue}>
                          {bomba.frecuencia && bomba.frecuencia.value
                            ? bomba.frecuencia.value
                            : 0}
                        </span>
                        <span style={styles.pumpMetricUnit}>
                          {bomba.frecuencia && bomba.frecuencia.unidad
                            ? bomba.frecuencia.unidad
                            : "Hz"}
                        </span>
                      </div>
                    </div>

                    {/* Corriente */}
                    <div
                      style={{
                        ...styles.pumpMetricRow,
                        ...(hoveredMetric === `${bomba.id}-corriente`
                          ? styles.pumpMetricRowHover
                          : {}),
                        ...(variableSeleccionada.column ===
                        (bomba.corriente && bomba.corriente.column)
                          ? styles.pumpMetricRowSelected
                          : {})
                      }}
                      onClick={() =>
                        bomba.corriente &&
                        bomba.corriente.column &&
                        handleVariableClick(
                          bomba.corriente.column,
                          `${bomba.title} - Corriente`
                        )
                      }
                      onMouseEnter={() =>
                        setHoveredMetric(`${bomba.id}-corriente`)
                      }
                      onMouseLeave={() => setHoveredMetric(null)}>
                      <span style={styles.pumpMetricLabel}>Corriente</span>
                      <div style={styles.pumpMetricValueContainer}>
                        <span style={styles.pumpMetricValue}>
                          {bomba.corriente && bomba.corriente.value
                            ? bomba.corriente.value
                            : 0}
                        </span>
                        <span style={styles.pumpMetricUnit}>
                          {bomba.corriente && bomba.corriente.unidad
                            ? bomba.corriente.unidad
                            : "A"}
                        </span>
                      </div>
                    </div>

                    {/* Estado */}
                    <div
                      style={{
                        ...styles.pumpMetricRow,
                        ...(hoveredMetric === `${bomba.id}-estado`
                          ? styles.pumpMetricRowHover
                          : {}),
                        ...(variableSeleccionada.column ===
                        (bomba.estado && bomba.estado.column)
                          ? styles.pumpMetricRowSelected
                          : {})
                      }}
                      onClick={() =>
                        bomba.estado &&
                        bomba.estado.column &&
                        handleVariableClick(
                          bomba.estado.column,
                          `${bomba.title} - Estado`
                        )
                      }
                      onMouseEnter={() =>
                        setHoveredMetric(`${bomba.id}-estado`)
                      }
                      onMouseLeave={() => setHoveredMetric(null)}>
                      <span style={styles.pumpMetricLabel}>Estado</span>
                      <span
                        style={{
                          ...styles.statusBadge,
                          backgroundColor: bomba.color
                        }}>
                        {bomba.estado && bomba.estado.value
                          ? bomba.estado.value
                          : "Desconocido"}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={styles.totalizadorSection}>
            <h2 style={styles.sectionTitle}>
              Totalizador Bomba P-{bombaPrefix}
            </h2>
            <div style={styles.totalizadorContainer}>
              <div
                style={{
                  ...styles.totalizadorCard,
                  ...(hoveredMetric === "horas-funcionamiento"
                    ? {
                        ...styles.totalizadorCard,
                        backgroundColor: "#e3f2fd",
                        transform: "scale(1.02)",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
                      }
                    : {}),
                  ...(variableSeleccionada.column ===
                  totalizadorData.horasFuncionamientoColumn
                    ? {
                        ...styles.totalizadorCard,
                        backgroundColor: "#bbdefb",
                        borderLeft: "4px solid #2196f3"
                      }
                    : {}),
                  cursor: "pointer",
                  transition: "all 0.2s ease"
                }}
                onClick={() =>
                  totalizadorData.horasFuncionamientoColumn &&
                  handleVariableClick(
                    totalizadorData.horasFuncionamientoColumn,
                    `P-${bombaPrefix} - Horas Funcionamiento`
                  )
                }
                onMouseEnter={() => setHoveredMetric("horas-funcionamiento")}
                onMouseLeave={() => setHoveredMetric(null)}>
                <div style={styles.totalizadorLabelContainer}>
                  <p style={styles.totalizadorLabel}>Horas</p>
                  <p style={styles.totalizadorSubLabel}>Funcionamiento</p>
                </div>
                <div style={styles.totalizadorValueContainer}>
                  <span style={styles.totalizadorValue}>
                    {totalizadorData.horasFuncionamiento}
                  </span>
                  <span style={styles.totalizadorUnit}>hrs</span>
                </div>
              </div>

              <div
                style={{
                  ...styles.totalizadorCard,
                  ...(hoveredMetric === "contador-arranques"
                    ? {
                        ...styles.totalizadorCard,
                        backgroundColor: "#e3f2fd",
                        transform: "scale(1.02)",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
                      }
                    : {}),
                  ...(variableSeleccionada.column ===
                  totalizadorData.contadorArranquesColumn
                    ? {
                        ...styles.totalizadorCard,
                        backgroundColor: "#bbdefb",
                        borderLeft: "4px solid #2196f3"
                      }
                    : {}),
                  cursor: "pointer",
                  transition: "all 0.2s ease"
                }}
                onClick={() =>
                  totalizadorData.contadorArranquesColumn &&
                  handleVariableClick(
                    totalizadorData.contadorArranquesColumn,
                    `P-${bombaPrefix} - Contador Arranques`
                  )
                }
                onMouseEnter={() => setHoveredMetric("contador-arranques")}
                onMouseLeave={() => setHoveredMetric(null)}>
                <div style={styles.totalizadorLabelContainer}>
                  <p style={styles.totalizadorLabel}>Contador</p>
                  <p style={styles.totalizadorSubLabel}>Arranques</p>
                </div>
                <div style={styles.totalizadorValueContainer}>
                  <span style={styles.totalizadorValue}>
                    {totalizadorData.contadorArranques
                      .toString()
                      .padStart(2, "0")}
                  </span>
                  <span style={styles.totalizadorUnit}>veces</span>
                </div>
              </div>
            </div>
          </div>

          {/* Sección de Selección de Fechas y Grafico de la Variable Monitoreada */}
        </div>
      )}

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 30,
          gap: 30,
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)"
        }}>
        {/* Sección de Selección de Fechas */}
        <div style={styles.dateRangeSection}>
          <Card style={styles.dateRangeCard}>
            <section
              style={{
                display: "flex",
                flexDirection: "row",
                rowGap: 20,
                columnGap: 40,
                flexWrap: "wrap"
              }}>
              <section
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  flexWrap: "wrap"
                }}>
                {/* Fecha Inicio */}
                <section>
                  <div style={styles.dateRange}>
                    <div style={styles.dateText}>Fecha Inicio</div>
                    <DatePicker2
                      value={startDate}
                      onChange={(cambio) => {
                        setStartDate(cambio);
                      }}
                      valueFormat={{
                        month: "numeric",
                        year: "numeric",
                        day: "numeric"
                      }}
                      calendarProps={{
                        min: new Date("2022-09-01 00:00:00"),
                        max: new Date(),
                        views: ["month"]
                      }}
                      messages={{
                        dateButton: "Seleccionar fecha",
                        moveBack: "",
                        moveForward: "",
                        moveToday: "Hoy"
                      }}
                    />
                  </div>
                </section>
                {/* Fecha Fin */}
                <section>
                  <div style={styles.dateRange}>
                    <div style={styles.dateText}>Fecha Fin</div>
                    <DatePicker2
                      value={endDate}
                      onChange={(cambio) => {
                        const fechaHoy = new Date();
                        if (
                          cambio.toLocaleDateString("en-US") !==
                          fechaHoy.toLocaleDateString("en-US")
                        ) {
                          cambio.setHours(23);
                          cambio.setMinutes(59);
                          cambio.setSeconds(59);
                        } else {
                          cambio.setHours(fechaHoy.getHours());
                          cambio.setMinutes(fechaHoy.getMinutes());
                          cambio.setSeconds(fechaHoy.getSeconds());
                        }
                        setEndDate(cambio);
                      }}
                      valueFormat={{
                        month: "numeric",
                        year: "numeric",
                        day: "numeric"
                      }}
                      calendarProps={{
                        min: new Date(2020, 2, 1),
                        max: new Date(),
                        views: ["month"]
                      }}
                      messages={{
                        dateButton: "Seleccionar fecha",
                        moveBack: "",
                        moveForward: "",
                        moveToday: "Hoy"
                      }}
                    />
                  </div>
                </section>
              </section>
              <section
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                {/* Botón Buscar Datos */}
                <section>
                  <div>
                    <Button
                      onClick={() => {
                        onClickBuscarDatos();
                      }}
                      color="info">
                      Buscar datos
                    </Button>
                  </div>
                </section>
                {/* Botón Exportar Datos */}
                {/* <section>
                  <div>
                    <Button
                      onClick={() => {
                        // Función para exportar datos
                        console.log("Exportar datos");
                      }}
                      color="info">
                      Exportar datos
                    </Button>
                  </div>
                </section> */}
              </section>
            </section>
          </Card>
        </div>

        {/* Sección de Variable Monitoreada */}
        <div style={styles.chartSection}>
          <div style={styles.variableMonitoreada}>
            {variableSeleccionada.column
              ? `Variable Monitoreada: ${variableSeleccionada.title}`
              : "No se ha seleccionado ninguna tarjeta o dispositivo"}
          </div>

          {variableSeleccionada.column && (
            <div style={styles.chartCard}>
              {variableSeleccionada.title &&
              variableSeleccionada.title.includes("Estado") ? (
                // Mostrar SimpleBarGraph para estados
                <SimpleBarGraph
                  idPlanta={idPlanta}
                  column={variableSeleccionada.column}
                  fecha={searchDates.start}
                  fechaFin={searchDates.end}
                />
              ) : (
                // Mostrar AreaChartData para otros parámetros
                <AreaChartData
                  idPlanta={idPlanta}
                  column={variableSeleccionada.column}
                  nombre={variableSeleccionada.title}
                  yMax={0}
                  yMin={0}
                  fechaInicio={searchDates.start}
                  fechaFin={searchDates.end}
                  showDecimals={false}
                />
              )}
            </div>
          )}
        </div>
      </section>
    </section>
  );
}